module.exports = __webpack_public_path__ + "static/img/introDownload.54dcf5eb.png";